/**
 * 扩展方式：
 * 1.基础模式：扩展形式采用class、构造函数定义；
 * 2.进阶模式：扩展形式采用对象字面量{ ... }定义；
 * 3.高阶模式：扩展形式采用Function定义；
 */
import { when } from 'mobx'
import { referFilters, awaitTo, getObjField, getJsonObj } from '../../utils/tools'

const btnTemp = [{
  libCode: "ynf-lib-base",
  onClick: "mobx://rootStore.actions.referEdit.doAction",
  visible: "mobx://rootStore.referStore.btnEditVisible",
  caption: "编辑",
  orderNum: 2,
  compType: "xbutton",
  controlType: "Button",
  alias: "btnEdit",
  iStyle: 1
}]

export default function (rootStore: any) {
  // 修改参照的模板
  rootStore.extendTemplete = (meta: any) => {
    const { cardBillno, dataMultiple } = rootStore.referInputProps
    const BillTemplate = meta.children.find((child: any) => child.controlType === 'BillTemplate')

    const filterUI = getObjField(BillTemplate, 'children', 'controlType', 'QueryScheme')
    const filterQueryUI = getObjField(BillTemplate, 'children', 'controlType', 'ConvenientQuery')
    rootStore.filterStore && (rootStore.filterStore.hasFilter = !!(filterUI || filterQueryUI))

    const filterContainer = BillTemplate.children.find((child: any) => child.children?.find((e: any) => e === filterUI || e === filterQueryUI ))
    if (filterContainer) { // 暂时这样补充---
      typeof filterContainer.visible == 'boolean' && (filterContainer.visible = 'mobx://rootStore.filterStore.filterVisible')
    } else if (filterQueryUI) {
      typeof filterQueryUI.visible == 'boolean' && (filterQueryUI.visible = 'mobx://rootStore.filterStore.filterVisible')
      typeof filterUI?.visible == 'boolean' && (filterUI.visible = 'mobx://rootStore.filterStore.filterVisible')
    }

    if (['Tree'].includes(rootStore.refEntity.cTpltype)) {
      const treeUI = getObjField(BillTemplate, 'children', 'controlType', 'Tree')

      treeUI && Object.assign(treeUI, {
        nodeEvents: [], // 树的行按钮-有他包含下级功能出不来
        checkable: dataMultiple, // 节点前添加 Checkbox 复选框
        titleField: rootStore.referInputProps.treeTitleFields || getJsonObj(rootStore.refEntity.cEntityNameFld, rootStore.refEntity.cEntityNameFld) || 'name', // 显示的字段名
        keyField: rootStore.referInputProps.valueField, // key取值的字段名
        // checkedKeys: [], // 选中复选框的树节点
        // selectedKeys: [], // 设置选中的树节点
        checkStrictly: true, // checkable 状态下节点选择完全受控（父子节点选中状态不再关联）
        searchValue: '', // 查询的关键词(高亮样式用)
        expandedKeys: 'mobx://rootStore.treeStore.expandedKeys', // 展开指定的树节点
        showButton: dataMultiple, // 多选树时展示包含同级/包含下级按钮
        selectable: true,
        showSearch: false,
        showLine: true, // 是否显示连接线
        showAddNode: false,
        store: 'mobx://rootStore.treeStore',
        checkedKeys: 'mobx://rootStore.treeStore.checkedKeys',
        onCheck: 'mobx://rootStore.treeStore.onExCheck',
        onSelect: 'mobx://rootStore.treeStore.onExSelect',
        // onDoubleClick: 'mobx://rootStore.treeStore.onExDoubleClick',
        onDoubleClick: 'onDoubleClick', // 这里统一走action
        onExpand: 'mobx://rootStore.treeStore.onExExpand',
        sameLevelClick: 'mobx://rootStore.treeStore.exSameLevelClick',
        nextLevelClick: 'mobx://rootStore.treeStore.exSnextLevelClick',
      })
    } else if (['Table'].includes(rootStore.refEntity.cTpltype)) {
      const tableUI = getObjField(BillTemplate, 'children', 'controlType', 'Table')

      tableUI && Object.assign(tableUI, {
        rowSelection: JSON.stringify({ multiple: dataMultiple }), // 单选、多选
        autoCheckedByClickRows: true, // 行点击自动勾选
        collect: 'mobx://rootStore.tableStore.collect',
        onRowDoubleClick: 'onDoubleClick', // 这里统一走action
        children: tableUI.children?.map((e: any) => ({...e, controlType: e.controlType === 'ReferInput' ? 'ReferInputPc' : e.controlType})),
        // onHandleScrollX: (left:any, type: any, args: any) => {
        //   if (args && args[2]) {
        //     args[2].stopPropagation();
        //     args[2].preventDefault();
        //   }
        // }
      })
      tableUI?.children.forEach((item: any) => {
        item.pageStore = 'mobx://rootStore.pageStore'
      })

      const toolBar = tableUI?.children.find((e: any) => e.controlType === 'ToolBar')
      toolBar && Object.assign(toolBar, {
        visible: !!cardBillno, // 行按钮
        children: btnTemp
      })
    } else if (['TreeTable'].includes(rootStore.refEntity.cTpltype)) {
      // const tableUI = meta.children.find((child: any) => child.controlType === 'BillTemplate').children.find((e: any) => e.controlType === 'Layout').children.find((e: any) => e.controlType === 'Table')
      // const treeUI = meta.children.find((child: any) => child.controlType === 'BillTemplate').children.find((e: any) => e.controlType === 'Layout').children.find((e: any) => e.controlType === 'Tree')
      // const viewUI = meta.children.find((e: any) => e.controlType == 'BillTemplate').children.find((e: any) => e.controlType == 'Layout')
      const tableUI = getObjField(BillTemplate, 'children', 'controlType', 'Table')
      const treeUI = getObjField(BillTemplate, 'children', 'controlType', 'Tree')
      const toolBar = tableUI?.children.find((e: any) => e.controlType === 'ToolBar')
      const viewUI = getObjField(BillTemplate, 'children', 'controlType', 'Layout')

      tableUI && Object.assign(tableUI, {
        rowSelection: JSON.stringify({ multiple: dataMultiple }), // 单选、多选
        autoCheckedByClickRows: true, // 行点击自动勾选
        onRowDoubleClick: 'onDoubleClick', // 这里统一走action
      })

      treeUI && Object.assign(treeUI, {
        showButton: false, // 行点击自动勾选
        titleField: rootStore.refEntity.cDataClass_lsName || rootStore.referInputProps.textField,
        keyField: rootStore.refEntity.cEntityKeyFld || rootStore.referInputProps.valueField,
      })

      toolBar && Object.assign(toolBar, {
        visible: !!cardBillno, // 行按钮
        children: btnTemp
      })

      viewUI?.children.forEach((item: any) => { // 删除布局容器上的默认样式
        delete item.cStyle
      })
    }
  }

  // 数据搜索
  rootStore.buildQuery = async (opt: any) => {
    const requestData = rootStore.referStore.getValue('requestData')
    const condition: any = referFilters.buildCondition(rootStore, opt);

    let res: any = {}
    let params: any = {}

    if (['Table'].includes(rootStore.refEntity.cTpltype)) {
      params = ['TreeList'].includes(rootStore.refEntity.originTpltype) ? { dataType: 'tree' } : { dataType: 'grid' }
    } else if (['Tree'].includes(rootStore.refEntity.cTpltype)) {
      params = { dataType: 'tree', page: undefined }
    } else if (['TreeTable'].includes(rootStore.refEntity.cTpltype)) {
      params = { dataType: 'grid', treeData: condition.treeData }
      delete condition.treeData
    }

    res = { ...requestData, ...params, ...condition, ...opt.params }
    res.masterOrgValue = rootStore.referInputProps.pageStore?.params?.masterOrgValue || rootStore.referInputProps.masterOrgValue
    res.isMasterOrg = rootStore.referInputProps.isMasterOrg

    return res
  }

  // 数据搜索
  rootStore.searchData = async (opt: any) => {
    if (rootStore.filterStore?.filterVisible) { // 查询区
      rootStore.filterStore.copyCondition()
      const { conditions = [] } = rootStore.filterStore.getQueryCondition()
      const simpleVOs = conditions.map((item: any) => ({
        logicOp: item?.op,
        conditions: item?.items?.map((e: any) => ({
          field: e.name, op: e.op, value1: e.v1,value2: e.v2
        }))
      }))
      opt.params = {...opt.params, filterCondition: { isExtend: true, simpleVOs }, likeValue: undefined }
    }

    const queryData = await rootStore.buildQuery(opt)
    if (opt.type === 'smartSearch') { // 智能搜索
      const smartData = { page: { pageIndex: 1, pageSize: 15 }, path: undefined }
      rootStore.referStore.setValue('smartSearchData', { ...queryData, ...smartData })
    } else if (opt.type === 'search') { // 搜索---所有搜索不设置默认pageIndex为1
      const pageInfo = opt.params?.page
      queryData.page = queryData.page ? { ...queryData.page, pageIndex: 1, totalCount: 0, ...pageInfo } : undefined
      rootStore.referStore.setValue('requestData', queryData)
    } else if (opt.type === 'dropDown') { // 搜索---所有搜索不设置默认pageIndex为1
      const dropDownPage = { page: { pageIndex: 1, pageSize: 9999 } }
      rootStore.referStore.setValue('requestData', { ...queryData, ...dropDownPage })
    } else if (opt.type === 'init') { // 初始化
      // queryData.page = ['Table', 'TreeTable'].includes(rootStore.refEntity.cTpltype) ? { pageIndex: 1, pageSize: 15, totalCount: 0 } : undefined
      rootStore.referStore.setValue('requestData', queryData)
    }

    // 请求标识
    rootStore.referStore.setValue('searchFlag', opt)
  }

  // 数据搜索
  rootStore.getRefData = async (opt: any) => {
    const queryData = await rootStore.buildQuery(opt)
    // 请求标识
    const [res] = await awaitTo(rootStore.actions.getRefData.doAction({ requestData: { ...queryData } }), undefined, rootStore.referInputProps)
    return res.recordList || []
  }

  // 参照弹窗确定
  rootStore.handleOk = async () => {
    const { onOk } = rootStore.referInputProps
    const data = await rootStore.getData()
    const res = await onOk?.(data, rootStore);
    if (res === false || res?.[1] === false) return
    rootStore.setData(data)
    rootStore.referStore.setValue('modalVisible', false)
  }

  // 打开参照
  rootStore.openRefer = async () => {
    await rootStore.referInputProps.onOpen?.({ store: rootStore }) // 发请求前
    rootStore.initRefData()
  }

  // 获取参照数据
  rootStore.getData = async () => {
    const { valueField } = rootStore.referInputProps
    let res = []
    if (['Table'].includes(rootStore.refEntity.cTpltype)) {
      res = rootStore.tableStore.getReferSelectedRows()
    } else if (['Tree'].includes(rootStore.refEntity.cTpltype)) {
      res = rootStore.treeStore.getKeyNodes()
    } else if (['TreeTable'].includes(rootStore.refEntity.cTpltype)) {
      res = rootStore.tableStore.getReferSelectedRows()
    }
    return res.filter((e: any) => e && e[valueField]).map((e: any) => ({ ...e, children: undefined }))
  }

  // 设置参照数据
  rootStore.setData = async (res: any = []) => {
    const { onChange, dataMultiple } = rootStore.referInputProps
    rootStore.referStore.setValue('referValue', res)
    // 更新显示值
    if (dataMultiple) { // 多选
      onChange?.(res)
    } else { // 单选
      const value = res.pop() || {};
      onChange?.(value)
    }
  }

  // 数据回显---这里会导致参照打开的时候也触发一次onChangeSelect
  rootStore.initRefData = async () => {
    const { value, multiple, valueField } = rootStore.referInputProps
    const data = (multiple ? value : value && Object.keys(value).length ? [value] : []) || []
    const dataKeys = data.map((e: any) => e[valueField])

    if (['Table'].includes(rootStore.refEntity.cTpltype)) {
      when(() => rootStore.tableStore.data.length, () => {
        rootStore.tableStore.clearMultiplePageSelectedData()
        rootStore.tableStore.setReferSelectRowKeys(data)
        rootStore.tableStore.selectedByRowKeys(dataKeys)
      })
    } else if (['Tree'].includes(rootStore.refEntity.cTpltype)) {
      when(() => rootStore.treeStore.dataSource.length, () => { rootStore.treeStore.onExCheck(dataKeys) })
    } else if (['TreeTable'].includes(rootStore.refEntity.cTpltype)) {
      when(() => rootStore.tableStore.data.length, () => {
        rootStore.tableStore.clearMultiplePageSelectedData()
        rootStore.tableStore.setReferSelectRowKeys(data)
        rootStore.tableStore.selectedByRowKeys(dataKeys)
      })
    }
  }
}
